import { CalendarCheck, Mails, MessagesSquare, MessageSquareText } from 'lucide-react'
import { FormattedText } from 'src/modules/core/components'
import type { PlanValueItem } from './plans-value-row.interface'
import classes from './plans-value-row.module.scss'

const VALUE_ITEMS: PlanValueItem[] = [
  { key: 'confirmations', Icon: MessageSquareText },
  { key: 'twoWayTexting', Icon: MessagesSquare },
  { key: 'moreThanReminders', Icon: Mails },
  { key: 'alwaysInSync', Icon: CalendarCheck },
]

export function PlansValueRow() {
  return (
    <section className={classes.row} data-testid="plans-value-row">
      <h3 className={classes.title}>
        <FormattedText id="payment.plans.value.title" />
      </h3>
      <div className={classes.items}>
        {VALUE_ITEMS.map(({ key, Icon }) => (
          <div key={key} className={classes.item}>
            <div className={classes.iconBox}>
              <Icon size={20} strokeWidth={1.8} aria-hidden />
            </div>
            <div>
              <div className={classes.itemTitle}>
                <FormattedText id={`payment.plans.value.${key}.title`} />
              </div>
              <div className={classes.itemText}>
                <FormattedText id={`payment.plans.value.${key}.description`} />
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  )
}
